import type { Identifiable } from '@empathyco/playboard-core-domain'
import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum'
import { getCurrentInstance } from 'vue'
import { FeatureIdEnum } from '../../enums'
import { CRUD_CONSTS } from '../../store/crud/crud.consts'
import { mapActions } from '../utils'

export async function useToolingReportToolConfiguration({
  tool,
  id,
}: {
  tool: FeatureIdEnum
  id: Identifiable['id']
}): Promise<any> {
  const {
    proxy: { $store },
  } = getCurrentInstance() as { proxy: Vue }

  const { read } = mapActions($store, CRUD_CONSTS.moduleName, {
    read: CRUD_CONSTS.actions.read,
  })

  const actionTypes: Partial<Record<FeatureIdEnum, ActionTypeEnum>> = {
    [FeatureIdEnum.PROMOTION]: ActionTypeEnum.PROMOTION,
  }
  try {
    const dataType = actionTypes[tool]
    if (!dataType) {
      throw new Error(`${tool} tool is not configured`)
    }

    const items = await read({
      dataType,
      ids: [id],
    })
    return items?.[0]?.data
  } catch (error: any) {
    // When the configuration no longer exists, the API returns a 404
    if (error?.status === 404) {
      return
    }
    throw error
  }
}
